// extracted by mini-css-extract-plugin
export default {"form":"styles_form__Md1fg","toggleItem":"styles_toggleItem__FjW8H","content":"styles_content__rlzJA","footer":"styles_footer__0oQ27","loader":"styles_loader__6473v"};